module.exports = __webpack_public_path__ + "static/member-4-7794f21b0d9a98da9c94518eeceeba7a.png";